import { render, staticRenderFns } from "./CardOceanLab.vue?vue&type=template&id=5d1c3746&"
import script from "./CardOceanLab.vue?vue&type=script&lang=js&"
export * from "./CardOceanLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports